import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import Reveal from "../common/Reveal";

/**
 * Visible FAQ section (also powers FAQPage schema for GEO / answer engines).
 * Pass `items` [{ q, a }], an optional eyebrow, title and subtitle.
 */
const FAQ = ({
  items = [],
  eyebrow = "FAQs",
  title = "Frequently Asked Questions",
  subtitle,
  className = "",
}) => {
  if (!items.length) return null;
  return (
    <section className={`py-20 lg:py-28 ${className}`}>
      <div className="tnf-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-4">
            <span className="tnf-eyebrow">{eyebrow}</span>
            <h2 className="font-display text-[30px] sm:text-[40px] font-extrabold text-[#0e0e10] mt-3 leading-[1.1]">
              {title}
            </h2>
            {subtitle && (
              <p className="text-[#3b3b3b]/80 text-[16px] mt-3 leading-relaxed">
                {subtitle}
              </p>
            )}
          </Reveal>

          <Reveal delay={120} className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full space-y-3">
              {items.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="bg-white rounded-2xl border border-black/5 px-5 sm:px-6 data-[state=open]:shadow-[0_14px_40px_rgba(0,0,0,0.06)] transition-shadow"
                >
                  <AccordionTrigger className="text-left font-display text-[16px] sm:text-[17px] font-semibold text-[#0e0e10] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[14.5px] text-[#3b3b3b]/85 leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
